import AuthProvider, { useAuthContext } from './components/AuthProvider';

export default AuthProvider;

export { useAuthContext };
